export default __webpack_public_path__ + "static/media/blog website.82b1b5fb.png";